const getFacilityNPI = ({ facility, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (facility && facility['Company Identify'] && facility['Company Identify']['Practice NPI']) {
    return facility['Company Identify']['Practice NPI'];
  }
  return null;
};

export default getFacilityNPI;



// WEBPACK FOOTER //
// ./src/utils/print/getFacilityNPI.js